import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, onMounted, ComputedRef } from "vue";
import SetupToggler from "@/views/pages/security/setup/SetupToggler.vue";
import { VerificationsPanelModel } from "@/views/pages/security/security";
import { VerificationTypes } from "@/models/verification/verification";
import GoogleCodeLogo from "@/components/forms/googlecode/GoogleCodeLogo.vue";
import CircleLoader from "@/components/loaders/CircleLoader.vue";

// Components registration (automatically handled in Vue 3 script setup, but needed in Vue 2.7)
interface ServiceBlock {
  service: VerificationTypes;
  model: VerificationsPanelModel;
  url: string;
  waiting: boolean;
  isEnabled: ComputedRef<boolean>;
  click: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationTypesPanel',
  setup(__props) {

const components = {
  CircleLoader,
  GoogleCodeLogo,
  SetupToggler
};

// Interface for service block
class ServiceBlockModel {
  service: VerificationTypes = VerificationTypes.SMS;
  waiting = false;
  model: VerificationsPanelModel;
  url = "/security/sms";

  constructor(service: VerificationTypes,
              model: VerificationsPanelModel,
              url: string) {
    this.service = service;
    this.model = model;
    this.url = url;
  }

  get isEnabled() {
    return this.model.settings.verification[this.service];
  }

  click() {
    this.waiting = true;
    setTimeout(() => {
      window.location.href = this.url;
    }, 500);
  }
}

// Create model
const model = reactive<VerificationsPanelModel>(new VerificationsPanelModel());

// Create service blocks
const sms = new ServiceBlockModel(VerificationTypes.SMS, model as VerificationsPanelModel, "/security/sms/");
const cert = new ServiceBlockModel(VerificationTypes.CERTIFICATE, model as VerificationsPanelModel, "/security/cert/");
const pin = new ServiceBlockModel(VerificationTypes.PIN, model as VerificationsPanelModel, "/security/pin/");
const table = new ServiceBlockModel(VerificationTypes.TABLECODE, model as VerificationsPanelModel, "/security/table/");
const google = new ServiceBlockModel(VerificationTypes.GOOGLECODE, model as VerificationsPanelModel, "/security/googlecode/");

// Computed properties
const isLoading = computed<boolean>(() => !model.loadingStatus.isLoaded);
const isPinSettingsAvail = computed<boolean>(() =>
  model.loadingStatus.isLoaded && model.settings.pinSettingsAvail
);
const isSmsSettingsAvail = computed<boolean>(() =>
  model.loadingStatus.isLoaded && model.settings.smsSettingsAvail
);

// Lifecycle hooks
onMounted(() => {
  model.loadSettings();
});

return { __sfc: true,components, ServiceBlockModel, model, sms, cert, pin, table, google, isLoading, isPinSettingsAvail, isSmsSettingsAvail, reactive, computed, onMounted, ComputedRef, SetupToggler, VerificationsPanelModel, VerificationTypes, GoogleCodeLogo, CircleLoader }
}

})